import React, {Component, Fragment} from "react"
import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import AccountTrophiesQuery, {accountTrophiesQuery} from "@irati/recognition/apollo/query/AccountTrophies"
import {TransitionFeed, DisablePointerEventsOnScroll} from "@irati/ui/src/Feed"
import padding from "@irati/ui/src/global/padding"
import scrollAtBottom from "@irati/utils/scroll/scrollAtBottom"
import Loader from "@irati/utils/services/apollo/Loading/Loader"
import {feedPollQuery} from "@irati/recognition/apollo/query/FeedPoll"
import {Query} from "@irati/utils/services/apollo"

import ErrorPopup from "../../../components/Popup/Error"
import Poll from "../../../components/Polls/ClosedPoll/Poll"
import EmptyTrophies from "../../../components/Polls/Empty/Trophies"
import LoadMore from "../../../components/LoadMore"
import PollPopup from "../../../components/Popup/Poll"

const Feed = styled(TransitionFeed)`
  margin-bottom: ${padding.base};
`

class Trophies extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pollId: null,
      variables: accountTrophiesQuery.variables,
      hasRefetchingError: false
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll = () => {
    const atBottom = scrollAtBottom()
    const {hasRefetchingError} = this.state

    if (atBottom && !hasRefetchingError && this.fetchMore) {
      this.fetchMore()
    }
  }

  handleAfterExitModal = () => {
    this.setState({
      pollId: null
    })
  }

  handleClickCard = (obj) => {
    this.setState({pollId: obj.uuid})
  }

  fetchMore = () => {
    this.setState({
      hasRefetchingError: false
    })
    this.fetchMore().catch(() => {
      this.setState({
        hasRefetchingError: true
      })
    })
  }

  hasReceivedData(data) {
    return data && "accountTrophies" in data && "results" in data.accountTrophies && data.accountTrophies.results.length > 0
  }

  render() {
    const {pollId, hasRefetchingError, variables} = this.state
    const winnersProps = {...accountTrophiesQuery, variables}

    return (
      <Fragment>
        <Card tiny noBorder>
          <DisablePointerEventsOnScroll>
            <AccountTrophiesQuery {...winnersProps}>
              {({data, refetch, fetchMore, loading: isLoading, error, networkStatus}) => {
                const hasData = this.hasReceivedData(data)
                const hasError = error || hasRefetchingError
                const isRefetching = networkStatus === 3

                const variablesToSend = hasData ? {...variables, cursor: data.accountTrophies.cursor} : variables

                this.fetchMore = !isLoading ? () => fetchMore(variablesToSend) : null

                return isLoading && !isRefetching ? (
                  <Loader />
                ) : (
                  <Fragment>
                    {hasData && (
                      <Fragment>
                        <Feed
                          arr={data.accountTrophies.results}
                          component={({item}) => <Poll onClick={this.handleClickCard} item={item} />}
                        />
                      </Fragment>
                    )}
                    {isLoading && <Loader />}
                    {!isLoading && hasError && <LoadMore onClick={error ? () => refetch() : this.fetchMore} />}
                    {!isLoading && !hasError && !hasData && <EmptyTrophies />}
                  </Fragment>
                )
              }}
            </AccountTrophiesQuery>
          </DisablePointerEventsOnScroll>
        </Card>
        {pollId && (
          <Query query={feedPollQuery.query} variables={{id: pollId}} Error={ErrorPopup}>
            {({data: {poll}}) => <PollPopup poll={poll} onAfterExitModal={this.handleAfterExitModal} />}
          </Query>
        )}
      </Fragment>
    )
  }
}

export default Trophies
